import { Desktop, Mobile } from '@edreamsodigeo/frontend-core';
import React from 'react';
import ValuePropositionMobile from '~/components/ValueProposition/ValuePropositionMobile';
import ValuePropositionDesktop from '~/components/ValueProposition/ValuePropositionDesktop';

const ValueProposition = () => {
  return (
    <>
      <Mobile>
        <ValuePropositionMobile />
      </Mobile>
      <Desktop>
        <ValuePropositionDesktop />
      </Desktop>
    </>
  );
};

export default ValueProposition;
